import { render, staticRenderFns } from "./m-editSelectionSNPMB.vue?vue&type=template&id=0941d9da&"
import script from "./m-editSelectionSNPMB.vue?vue&type=script&lang=js&"
export * from "./m-editSelectionSNPMB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports